// JawlineFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const jawlineFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Jawline Fillers Dubai | Elite Body Home Polyclinic",
            "description": "Jawline fillers are a popular cosmetic treatment designed to contour and define the jawline, providing a more sculpted and youthful appearance. At Elite Body Home Polyclinic, we offer advanced dermal filler solutions that effectively reshape and enhance the jawline without the need for surgery.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/jawline-fillers-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Jawline Fillers Dubai | Elite Body Home Polyclinic",
                "description": "Jawline fillers are a popular cosmetic treatment designed to contour and define the jawline, providing a more sculpted and youthful appearance. At Elite Body Home Polyclinic, we offer advanced dermal filler solutions that effectively reshape and enhance the jawline without the need for surgery.",
                "url": "https://elitebodyhome.com/jawline-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-13T15:42:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "jawline filler",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Jawline Fillers Dubai | Elite Body Home Polyclinic",
                "description": "Jawline fillers are a popular cosmetic treatment designed to contour and define the jawline, providing a more sculpted and youthful appearance. At Elite Body Home Polyclinic, we offer advanced dermal filler solutions that effectively reshape and enhance the jawline without the need for surgery.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Jawline Fillers Dubai"],
        "hero": {
            "title": "Jawline Fillers in Dubai",
            "subtitle": "Enhance Your Jawline with Dermal Fillers",
            "description": "Jawline fillers are a popular type of cosmetic treatment that are used to contour and define the jawline, giving the face a more sculpted and youthful look. To redefine the jawline confidently and without surgery, at Elite Body Home Polyclinic we provide advanced dermal filler solutions. Whether you want to achieve a more voluminous profile, enhance the balance of your face, or even correct minor asymmetries, jawline fillers can provide fantastic results in a fast, non-invasive treatment."
        },
        "howItWorks": {
            "title": "How Does Jawline Filler Work",
            "description": "Jawline filler utilizes dermal fillers, which usually contain hyaluronic acid or other biocompatible materials, to augment the contour and definition of the jawline. Filler is injected strategically along the jawline to provide volume, sculpt the shape, and achieve a more contoured effect. It can correct asymmetry, minimize jowls and give a more sharp, youthful appearance. Results are seen almost immediately, have little to no downtime, and last anywhere from 6 to 18 months, depending on what type of filler you get."
        },
        "procedureSteps": {
            "heading": "Jawline Fillers | How Jawline Fillers Work?",
            "para": "Juvederm Voluma is the first FDA approved injectables specifically created for facial contouring, which makes it perfect for jawline fillers. The procedure is minimally invasive and generally completed within an hour.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Step one is a consultation to evaluate your face and talk about what you hope to achieve.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Filler Selection",
                    "desc": "The most common type is hyaluronic acid based filler because the result looks natural and it is well tolerated by the body.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Application",
                    "desc": "The filler is injected into the jawline area with fine needles or cannulas. We will determine how many injections and how much filler the patient needs.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Aftercare",
                    "desc": "After the procedure, patients can resume daily activities after a few days, however they should avoid any vigorous activity for 24-48 hours. Jawline fillers are a more effective & safer method for a more sculpted & aligned jawline without surgery.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "Jawline fillers have a number of visual and confidence boosting advantages. This well-organized process is based on so many sorting preferences thereby every patient gets what they want.",
            "items": [
                {
                    "title": "Enhanced Jawline Definition",
                    "desc": "A filler injection creates a more visible jawline.",
                    "icon": "fa-solid fa-vector-square"
                },
                {
                    "title": "Non-Surgical Approach",
                    "desc": "The process is safer and faster than its surgical counterparts, with no need for incisions or anesthesia.",
                    "icon": "fa-solid fa-times-circle"
                },
                {
                    "title": "Improved Facial Proportions",
                    "desc": "Fillers can correct asymmetry and create facial harmony, balancing the face.",
                    "icon": "fa-solid fa-balance-scale"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Typical patients return to their normal activities after the procedure.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Filling the cheeks gives a smoother natural enhancement of the overall appearance.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Customizable Treatment",
                    "desc": "The treatment is completely tailored according to the patient's face structure and beauty goals.",
                    "icon": "fa-solid fa-user-cog"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Jawline fillers are appropriate for both women and men who want to enhance their facial structure. But it's important to find out if this treatment is right for you.",
            "items": [
                {
                    "title": "People with Mild to Moderate Volume Loss",
                    "desc": "People showing signs of early aging who are looking to enhance jawline definition.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Patients Wanting to Avoid Surgery",
                    "desc": "Best suited for those who want a non-invasive treatment that enhances their looks.",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "For those who Want Facial Contouring",
                    "desc": "Ideal for those who want to improve the structure and angles of their face.",
                    "icon": "fa-solid fa-drafting-compass"
                },
                {
                    "title": "Good General Health",
                    "desc": "Candidates ought to be in good health without significant underlying medical conditions.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "It is vital to have realistic expectations for what the results will be, and to acknowledge that fillers are temporary improvements.",
                    "icon": "fa-solid fa-lightbulb"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "The best results come from proper preparation for jawline fillers. Avoiding these mistakes is key to minimizing the risks of this process and making it as straightforward as possible.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Stop taking aspirin, ibuprofen or any blood-thinning medications for at least a week before the procedure to minimize the risk of bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "It's also important to validate the skin and body drunk plenty of water, to achieve optimal results.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "No Alcohol or Smoking",
                    "desc": "Refrain from alcohol and smoking for 24-48 hours leading up to the procedure, as these interfere with the healing process.",
                    "icon": "fa-solid fa-smoking-ban"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Jawline fillers provide adding to the facial profile with minimal to no downtime. It is very satisfying for patients as the definition of the jawline and facial symmetry often improves immediately following treatment.",
            "items": [
                {
                    "title": "Instant Improvement",
                    "desc": "Results are immediate with the ultimate effect being seen after any swelling goes down.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "If you take proper care, jawline fillers can last more than a year.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Natural-Looking Contours",
                    "desc": "Fillers provide subtle, natural looks and fillers that least hits your face.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "Boost in Confidence",
                    "desc": "Improved self-esteem and confidence in appearance with a sharper, more defined jawline.",
                    "icon": "fa-solid fa-thumbs-up"
                }
            ]
        },
        "aftercareTips": {
            "heading": "To Maintain Jawline Fillers in Dubai: Why Select Elite Body Home?",
            "subheading": "",
            "para": "Jawline fillers are ideal for individuals who want to add subtle definition and contours to their face for a more sculpted, youthful appearance. Using the latest techniques and high-quality dermal fillers at Elite Body Home Polyclinic, you can rest assured that your results will be safe, satisfying, and long-lasting. We can help you learn more about jawline fillers who work best for you, so contact our team today!",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Got questions about Jawline Fillers? Here are some answers to help you feel informed and confident.",
            "items": [
                {
                    "question": "What are jawline fillers made of?",
                    "answer": "Most jawline fillers are made of hyaluronic acid, a naturally occurring substance in the body. This helps in achieving defined yet natural-looking enhancements."
                },
                {
                    "question": "How long do jawline fillers last?",
                    "answer": "Jawline fillers typically last between 12 to 18 months, depending on the product used and individual metabolism. Periodic touch-ups can help maintain results."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "Most patients experience minimal discomfort. A topical numbing cream is usually applied to make the procedure as comfortable as possible."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include temporary swelling, bruising, or redness at the injection site. These effects usually resolve within a few days."
                },
                {
                    "question": "Can jawline fillers be reversed?",
                    "answer": "Yes, if hyaluronic acid-based fillers are used, the results can be reversed using an enzyme called hyaluronidase. This makes the treatment flexible and low-risk."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/rtuytjyt-3.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/123.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/125.webp",
            ]
        },
        "product": {
            "id": 108,
            "title": "Jawline Filler Contouring Package",
            "price": 500,
            "description": "Non-surgical jawline enhancement using advanced dermal fillers to sculpt, define, and rejuvenate facial contours with natural-looking precision and minimal downtime."
        },
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "فيلر خط الفك في دبي | Elite Body Home Polyclinic",
            "description": "يُعد فيلر خط الفك علاج تجميلي شائع يُستخدم لنحت وإبراز خط الفك، مما يمنح الوجه مظهرًا أكثر تحديدًا وأكثر شبابًا. نقدم في ايليت بودي هوم حلولًا متقدمة من الفيلر لإعادة تشكيل خط الفك بثقة ودون الحاجة إلى الجراحة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/jawline-fillers-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "فيلر خط الفك في دبي | Elite Body Home Polyclinic",
                "description": "يُعد فيلر خط الفك علاج تجميلي شائع يُستخدم لنحت وإبراز خط الفك، مما يمنح الوجه مظهرًا أكثر تحديدًا وأكثر شبابًا. نقدم في ايليت بودي هوم حلولًا متقدمة من الفيلر لإعادة تشكيل خط الفك بثقة ودون الحاجة إلى الجراحة.",
                "url": "https://elitebodyhome.com/services/jawline-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-13T15:42:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "فيلر خط الفك",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "فيلر خط الفك في دبي | Elite Body Home Polyclinic",
                "description": "يُعد فيلر خط الفك علاج تجميلي شائع يُستخدم لنحت وإبراز خط الفك، مما يمنح الوجه مظهرًا أكثر تحديدًا وأكثر شبابًا. نقدم في ايليت بودي هوم حلولًا متقدمة من الفيلر لإعادة تشكيل خط الفك بثقة ودون الحاجة إلى الجراحة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-52.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر خط الفك في دبي"],
        "hero": {
            "title": "فيلر خط الفك في دبي",
            "subtitle": "تحديد ملامح خط الفك وتعزيز جماله بالفيلر",
            "description": "يُعد فيلر خط الفك علاج تجميلي شائع يُستخدم لنحت وإبراز خط الفك، مما يمنح الوجه مظهرًا أكثر تحديدًا وأكثر شبابًا. نقدم في ايليت بودي هوم حلولًا متقدمة من الفيلر لإعادة تشكيل خط الفك بثقة ودون الحاجة إلى الجراحة. سواء كنت ترغب في تحسين تناسق ملامح وجهك، أو الحصول على مظهر أكثر تحديدًا، أو تصحيح عدم تناسق بسيط، فإن فيلر خط الفك يوفر نتائج رائعة من خلال إجراء سريع وغير جراحي."
        },
        "howItWorks": {
            "title": "كيف يعمل فيلر خط الفك؟",
            "description": "يعتمد على حقن الفيلر المكون من حمض الهيالورونيك أو مواد أخرى متوافقة مع الجسم، لتعزيز تحديد خط الفك وإبراز ملامحه. يُحقن الفيلر بدقة على طول خط الفك لإضافة الحجم، ونحت شكل الفك، وتحقيق مظهرًا أكثر تحديدًا. يساعد هذا الإجراء على تصحيح عدم التناسق الفك، وتقليل الترهل، وإضفاء مظهرًا أكثر تحديدًا وشبابًا. تظهر النتائج فورًا بعد الجلسة، مع فترة تعافي قصيرة جدًا، وتدوم النتائج من 6 إلى 18 شهرًا عادةً حسب نوع الفيلر المستخدم."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء فيلر خط الفك",
            "para": "يُعد فيلر فولوما جوفيديرم أول فيلر معتمد من إدارة الغذاء والدواء الأمريكية (FDA)، مُصمم خصيصًا لإعادة تحديد ملامح الوجه، مما يجعله مثاليًا لتحديد خط الفك. يتميز هذا الإجراء بكونه غير جراحي وسريع، حيث يستغرق أقل من ساعة.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تبدأ الجلسة بتقييم ملامح الوجه ومناقشة التوقعات والأهداف.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "اختيار الفيلر",
                    "desc": "يُستخدم فيلر مكون من حمض الهيالورونيك لنتائج طبيعية ومتناسقة، ولتوافقه مع الجسم.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "الحقن",
                    "desc": "يُحقن الفيلر بدقة في منطقة خط الفك باستخدام إبر أو قنيات دقيقة، ويتم تحديد الكمية اللازمة وفقًا لاحتياج كل شخص.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "العناية بعد الجلسة",
                    "desc": "يمكن العودة إلى الأنشطة اليومية خلال أيام قليلة، مع ضرورة تجنب المجهود البدني الشديد لمدة 24-48 ساعة. يُعد فيلر خط الفك خيارًا فعالًا وآمنًا لنحت الفك وتحقيق تناسق مثالي دون الحاجة إلى تدخل جراحي.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد فيلر خط الفك",
            "subheading": "",
            "para": "يُوفر فيلر خط الفك العديد من الفوائد الجمالية التي تعزز الثقة بالنفس، حيث يتم تخصيص كل علاج بما يتناسب مع ملامح كل شخص لتحقيق أفضل النتائج الطبيعية.",
            "items": [
                {
                    "title": "تحسين تحديد الفك",
                    "desc": "يساعد حقن الفيلر في إبراز ملامح الفك بشكل أكثر تناسقًا.",
                    "icon": "fa-solid fa-vector-square"
                },
                {
                    "title": "إجراء غير جراحي",
                    "desc": "يعد الإجراء أكثر أمانًا وأسرع من البدائل الجراحية، حيث لا يتطلب جروحًا أو تخديرًا.",
                    "icon": "fa-solid fa-times-circle"
                },
                {
                    "title": "تحسين تناسق ملامح الوجه",
                    "desc": "يعمل على تصحيح عدم التناسق وإضفاء توازن مثالي على الملامح.",
                    "icon": "fa-solid fa-balance-scale"
                },
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "يمكن لمعظم المرضى العودة إلى أنشطتهم اليومية فورًا بعد الجلسة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "يمنح ملء الخدين الوجه مظهرًا أكثر تحديدًا ونعومة دون مبالغة.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "خطط علاجية مخصصة",
                    "desc": "يُصمم الإجراء بما يتناسب مع شكل الوجه والأهداف الجمالية لكل شخص.",
                    "icon": "fa-solid fa-user-cog"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشح المناسب لفيلر خط الفك",
            "subheading": "",
            "para": "يعد فيلر الفك خيارًا مناسبًا لكل من النساء والرجال الذين يسعون إلى تحسين بنية وجوههم، ولكن من المهم التأكد من أن هذا العلاج مناسبًا لك. إليك الأشخاص الملائمين للعلاج:",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من فقدان خفيف إلى متوسط في حجم الوجه",
                    "desc": "يناسب من يعانون من علامات الشيخوخة المبكرة ويرغبون في تحديد الفك بشكل أفضل.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "المرضى الذين يفضلون تجنب العمليات الجراحية",
                    "desc": "يناسب من يبحث عن إجراء غير جراحي لتحسين ملامح الوجه.",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "الأشخاص الذين يرغبون في تحديد ملامح الوجه",
                    "desc": "يعد خيار مثالي لمن يسعى إلى تحسين بنية الوجه وزواياه للحصول على مظهر أكثر تناسقًا.",
                    "icon": "fa-solid fa-drafting-compass"
                },
                {
                    "title": "الأصحاء البالغون",
                    "desc": "يجب أن يكون المرشحون بصحة جيدة وألا يعانوا من مشكلات طبية خطيرة قد تؤثر على العلاج.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "الأشخاص الذين يمتلكون توقعات واقعية",
                    "desc": "يُعد من المهم أن يكون لدى المرشحين فهم واضح لما يمكن تحقيقه من خلال الفيلر، مع العلم أن النتائج مؤقتة ويمكن الحفاظ عليها من خلال جلسات متابعة.",
                    "icon": "fa-solid fa-lightbulb"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يجب التحضير الجيد قبل الخضوع لجلسة فيلر خط الفك، لضمان الحصول على أفضل النتائج وتقليل المخاطر محتملة. إليك بعض الخطوات الأساسية:",
            "items": [
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو الأدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة لتجنب ظهور كدمات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب كميات كافية من الماء في تعزيز صحة البشرة وتحقيق نتائج مثالية للفيلر.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "الامتناع عن التدخين والكحول",
                    "desc": "يُنصح بتجنب الكحول والتدخين لمدة 24-48 ساعة قبل الجلسة، حيث يمكن أن يؤثرا على عملية الشفاء والنتائج النهائية.",
                    "icon": "fa-solid fa-smoking-ban"
                }
            ]
        },
        "results": {
            "heading": "نتائج فيلر خط الفك",
            "subheading": "",
            "para": "يُعد فيلر الفك خيارًا فعالًا لتعزيز مظهر الوجه وإبراز ملامحه مع الحد الأدنى من فترة التعافي. يشعر المرضى برضا كبير عن النتائج، حيث تتحسن ملامح الفك وتناسق الوجه بشكل واضح فور الانتهاء من الإجراء.",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "يُلاحظ التحسن فورًا بعد الإجراء، مع ظهور النتيجة النهائية بعد زوال التورم الطفيف.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "نتائج تدوم طويلًا",
                    "desc": "يمكن أن تستمر نتائج الفيلر لأكثر من عام عند اتباع العناية المناسبة.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "تحديد طبيعي للوجه",
                    "desc": "يعمل الفيلر على تعزيز شكل خط الفك طبيعيًا، مما يمنحك مظهراً متناسقاً دون تغيير جذري في الملامح.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يساعد الحصول على فك أكثر تحديدًا وتناسقًا في تعزيز الشعور بالثقة والرضا عن المظهر.",
                    "icon": "fa-solid fa-thumbs-up"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا يجب اختيار عيادات ايليت بودي هوم في دبي؟",
            "subheading": "",
            "para": "يعتبر فيلر تحديد خط الفك هو الحل الأمثل لمن يرغب في إبراز ملامح الوجه ومنحها مظهراً أكثر شباباً وتناسقاً دون الحاجة إلى جراحة. نستخدم في ايليت بودي هوم أحدث التقنيات وأفضل أنواع الفيلر لضمان نتائج آمنة وطبيعية، وتدوم طويلًا. يمكننا مساعدتك في معرفة المزيد عن فيلر تحديد خط الفك ومعرفة الخيار الأنسب لك، لذا تواصل مع فريقنا اليوم!",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "هل لديك أسئلة حول فيلر خط الفك؟ إليك بعض الإجابات لمساعدتك على الشعور بالاطمئنان.",
            "items": [
                {
                    "question": "مما يتكون فيلر خط الفك؟",
                    "answer": "يتكون معظم فيلر خط الفك من حمض الهيالورونيك، وهي مادة طبيعية موجودة في الجسم. هذا يساعد في تحقيق تحسينات طبيعية المظهر."
                },
                {
                    "question": "كم تدوم نتائج فيلر خط الفك؟",
                    "answer": "تدوم نتائج فيلر خط الفك عادةً من 12 إلى 18 شهرًا، اعتمادًا على المنتج المستخدم وطبيعة الجسم. يمكن الحفاظ على النتائج من خلال جلسات المتابعة الدورية."
                },
                {
                    "question": "هل الإجراء مؤلم؟",
                    "answer": "يشعر معظم المرضى بانزعاج طفيف. عادةً ما يتم تطبيق كريم مخدر موضعي لجعل الإجراء مريحًا قدر الإمكان."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورمًا مؤقتًا أو كدمات أو احمرارًا في موقع الحقن. تزول هذه الآثار عادةً في غضون أيام قليلة."
                },
                {
                    "question": "هل يمكن عكس نتائج فيلر خط الفك؟",
                    "answer": "نعم، إذا تم استخدام فيلر حمض الهيالورونيك، فيمكن عكس النتائج باستخدام إنزيم يسمى هيالورونيداز. وهذا يجعل العلاج مرنًا ومنخفض المخاطر."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []

    }
};
